export enum Catalog {
  All = 0,
  Sport = 1,
}

export interface IAuctionFilterDto {
  idLanguage: number;
  searchText: string;
  idAuctionType: number;
  idDetail: number | null;
  onlySigned: boolean;
  onlyFavorites?: boolean;
  idSport: number | null;
  idCompetition: number | null;
  idTeam: number | null;
  idSeason: number | null;
  onlyNew: boolean;
  onlyExpiring: boolean;
  onlyArriving: boolean;
  onlyBuyNow: boolean;
  auctionStatus: FilterStatus;
  idEntityList: number[];
  idCampaignList: number[];
  idPromoterList: number[];
  idActiveAuction: number | null;
  idTagList: number[];
  idCategoriesList?: number[];
  orderBy: 'evidence' | 'price' | 'endDate';
  orderDirection: 'asc' | 'desc';
  catalog: Catalog;
  limit?: number;
  offset?: number;
}

export enum FilterStatus {
  All = -1,
  OnlyActive = 1,
  Closed = 2,
}

export interface ArticlePropertyFilter {
  idTypeProperty: number;
  value: string;
}

export interface GetAllFilterPropertiesDto {
  articlePropertyFilterList: ArticlePropertyFilter[];
  idArticleType: number;
}

export interface FilterProperty {
  itemOrder: number;
  ids: string;
}

export interface FilterPropertyValue {
  itemOrder: number;
  value: string;
}
